import { api } from '@services';

interface ICreateAccount {
  name: string;
  email: string;
  password: string;
  role: string;
  type: string;
  studioId?: string;
  manufacturerId?: string;
}

const createAccount = async (data: ICreateAccount): Promise<void> => {
  await api.post('/users', data);
};

export { createAccount };
